function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M437.022,74.984C388.67,26.63,324.381,0,256,0C187.624,0,123.338,26.63,74.984,74.984S0,187.624,0,256 c0,68.388,26.63,132.678,74.984,181.028C123.335,485.375,187.621,512,256,512c68.385,0,132.673-26.625,181.021-74.972 C485.372,388.679,512,324.389,512,256C512,187.623,485.372,123.336,437.022,74.984z M425.708,425.714 C380.381,471.039,320.111,496,256,496c-64.106,0-124.374-24.961-169.703-70.286C40.965,380.386,16,320.113,16,256 c0-64.102,24.965-124.37,70.297-169.703C131.63,40.965,191.898,16,256,16c64.108,0,124.378,24.965,169.708,70.297 C471.037,131.628,496,191.896,496,256C496,320.115,471.037,380.387,425.708,425.714z"
}), React.createElement("path", {
  d: "M430.038,114.969c-2.783-3.432-7.821-3.956-11.253-1.172c-3.431,2.784-3.956,7.822-1.172,11.252 C447.526,161.919,464,208.426,464,256c0,55.567-21.635,107.803-60.919,147.085C363.797,442.367,311.563,464,256,464 c-51.26,0-100.505-18.807-138.663-52.956c-3.292-2.946-8.35-2.666-11.296,0.626s-2.666,8.35,0.626,11.296 C147.763,459.745,200.797,480,256,480c59.837,0,116.089-23.297,158.394-65.601C456.701,372.095,480,315.84,480,256 C480,204.767,462.256,154.681,430.038,114.969z"
}), React.createElement("path", {
  d: "M48,256c0-114.691,93.309-208,208-208c51.26,0,100.504,18.808,138.662,52.959c3.293,2.948,8.35,2.666,11.296-0.625 c2.947-3.292,2.667-8.35-0.625-11.296C364.237,52.256,311.203,32,256,32c-59.829,0-116.08,23.301-158.389,65.611 C55.301,139.921,32,196.171,32,256c0,51.239,17.744,101.328,49.963,141.038c1.581,1.949,3.889,2.96,6.217,2.96 c1.771,0,3.553-0.585,5.036-1.788c3.431-2.784,3.956-7.822,1.172-11.253C64.474,350.088,48,303.58,48,256z"
}), React.createElement("path", {
  d: "M398.655,194.764c1.975-2.959,1.757-6.867-0.533-9.59c-2.29-2.722-6.102-3.604-9.357-2.167 c-0.204,0.09-0.408,0.18-0.612,0.268c1.881-3.375,3.437-6.949,4.63-10.676c1.014-3.166-0.035-6.628-2.635-8.698 c-2.6-2.071-6.209-2.317-9.067-0.622c-8.072,4.792-16.708,8.314-25.726,10.498c-10.798-9.778-25.002-15.307-39.646-15.307 c-32.47,0-58.887,26.402-58.887,58.855c0,0.928,0.021,1.854,0.063,2.776c-34.859-4.249-67.035-21.913-89.417-49.384 c-1.658-2.035-4.206-3.128-6.826-2.922c-2.617,0.205-4.967,1.68-6.288,3.948c-5.214,8.949-7.97,19.185-7.97,29.602 c0,9.952,2.486,19.542,7.052,28.008c-1.225,0.081-2.435,0.444-3.528,1.088c-2.443,1.438-3.942,4.06-3.942,6.895v0.636 c0,17.624,7.908,33.796,20.616,44.719c-0.275,0.237-0.536,0.495-0.78,0.772c-1.859,2.112-2.473,5.045-1.615,7.725 c5.467,17.082,18.25,30.333,34.264,36.714c-13.001,6.537-27.355,9.933-42.315,9.933c-3.772,0-7.544-0.216-11.211-0.643 c-3.698-0.431-7.206,1.748-8.458,5.255c-1.253,3.507,0.08,7.414,3.214,9.425C164.291,367.657,192.755,376,221.996,376 c57.454,0,93.424-27.125,113.482-49.88c24.968-28.326,39.288-65.827,39.288-102.89c0-0.914-0.007-1.804-0.022-2.676 C384.046,213.282,392.077,204.623,398.655,194.764z M361.931,210.17c-2.198,1.585-3.444,4.176-3.311,6.883 c0.097,1.97,0.145,3.99,0.145,6.177c0,33.221-12.863,66.866-35.29,92.31C305.597,335.822,273.479,360,221.996,360 c-15.75,0-31.25-2.705-45.896-7.938c17.51-3.161,33.891-10.506,48.153-21.695c2.662-2.088,3.723-5.626,2.648-8.835 c-1.075-3.208-4.052-5.394-7.436-5.458c-14.083-0.265-26.831-7.364-34.527-18.535c4.015-0.244,8.006-0.896,11.91-1.951 c3.583-0.967,6.029-4.272,5.91-7.981c-0.119-3.709-2.774-6.849-6.411-7.584c-15.937-3.219-28.377-15.183-32.716-30.254 c4.279,1.13,8.688,1.784,13.119,1.932c3.577,0.122,6.79-2.146,7.883-5.548c1.094-3.402-0.203-7.118-3.175-9.102 c-11.942-7.97-19.071-21.318-19.071-35.707c0-3.646,0.462-7.259,1.363-10.751c26.808,27.682,63.308,44.387,101.994,46.315 c2.526,0.125,4.93-0.936,6.54-2.863c1.609-1.928,2.22-4.5,1.649-6.946c-0.735-3.149-1.108-6.438-1.108-9.775 c0-23.63,19.239-42.855,42.887-42.855c11.804,0,23.217,4.931,31.314,13.527c1.884,2,4.664,2.894,7.358,2.367 c3.031-0.593,6.028-1.312,8.986-2.156c-1.483,1.179-3.052,2.266-4.696,3.25c-3.236,1.938-4.679,5.872-3.463,9.442 c1.216,3.571,4.757,5.809,8.506,5.367c1.303-0.153,2.602-0.329,3.897-0.529C365.78,207.282,363.885,208.76,361.931,210.17z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var Svg004Twitter = function Svg004Twitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg004Twitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/004-twitter.042fe30f.svg";
export { ForwardRef as ReactComponent };